module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tomorrow":"завтра","after_tomorrow":"послезавтра","week_later":"через неделю"},"uz":{"tomorrow":"ertaga","after_tomorrow":"ertadan keyin","week_later":"bir haftadan keyin"}}')
  delete Component.options._Ctor
}
